import "@babel/polyfill";
import Vue from "vue";
import "./Plugins/axios";
import "./Plugins/vuetify";
import "./Plugins/appinsights";
import App from "./App.vue";
import router from "./router";
import store from "./Store/index";
import "./registerServiceWorker";


Vue.config.productionTip = false;


fetch("/api/config") // ensure we have loaded the config for this environment before initializing the app.
	.then(response => {
		return response.json();
	})
	.then(data => {
		new Vue({
			router,
			store,
			data() { return { env: data }; }, // little hacky for passing data to App.
			render: (h) => h(App),
		})
			.$mount("#app");
	})
	.catch(err => {
		console.error(err);
	});
